import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { trackEvent } from "../hooks/useAnalytics";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u?.startsWith("http") ? u : `${BACKEND}${u}`);

export default function GalleryModal({ event, onClose }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (event?.id) trackEvent(`gallery_open:${event.id}`);
  }, [event?.id]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setIdx((i) => (i + 1) % event.gallery.length);
      if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + event.gallery.length) % event.gallery.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [event, onClose]);

  if (!event) return null;
  const photos = event.gallery || [];
  if (photos.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex flex-col" onClick={onClose}>
      <div className="flex justify-between items-center p-4 text-white" onClick={(e) => e.stopPropagation()}>
        <div>
          <div className="font-cursive text-2xl">{event.title}</div>
          <div className="text-xs opacity-70">{event.date} · {idx + 1} / {photos.length}</div>
        </div>
        <button onClick={onClose} className="p-2 bg-white/10 hover:bg-white/20 rounded-full">
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center relative px-4 pb-4" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setIdx((i) => (i - 1 + photos.length) % photos.length)} className="absolute left-4 p-3 bg-white/10 hover:bg-white/20 rounded-full text-white">
          <ChevronLeft className="w-6 h-6" />
        </button>
        <img src={abs(photos[idx])} alt="" className="max-h-[75vh] max-w-full object-contain rounded-xl shadow-2xl" />
        <button onClick={() => setIdx((i) => (i + 1) % photos.length)} className="absolute right-4 p-3 bg-white/10 hover:bg-white/20 rounded-full text-white">
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      <div className="px-4 pb-4 overflow-x-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex gap-2">
          {photos.map((u, i) => (
            <button key={u} onClick={() => setIdx(i)} className={`shrink-0 w-16 h-16 rounded overflow-hidden ring-2 ${i === idx ? "ring-white" : "ring-transparent opacity-60 hover:opacity-100"}`}>
              <img src={abs(u)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
